export * from './baMsgCenter.component';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baMsgCenter/index.ts